module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2b",
    attrs: {
      "id": "ch3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("Empty")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Summers were sweet like molasses, but they passed as if ushered out by Mercury himself. This summer, though, I was anxious for the business that September would bring. Immersion in reading, essays, and grading tests would help me forget the sting of this summer’s events. My only brother had gotten married, and I felt betrayed because I hadn’t been included in the wedding ceremony. It felt like the final betrayal after a lifetime of disappointments. My mother tried to keep me from calling it that, but that’s what it felt like, so I spent my summer hurting and trying to heal. But nothing helped me heal or forget my emotional wounds like loving. It’s what I learned to do long ago, with intense lust and intertwined limbs. But I couldn’t do that anymore. I had to love with my heart. And that’s how I met Marley.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83e08dfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter03.vue
// module id = 87
// module chunks = 0